export const platformManaged = 'EIAP';
export const selectedEnv = 'Development';
export const imageURL = '/static/images/optional-ri';
export default {};
